// global imports
import { Grid, InputLabel, makeStyles, StyleRules, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { withLocalize } from 'react-localize-redux';
import { useDispatch, useSelector } from 'react-redux';
import GridItem from '../../../../components/Grid/GridItem';
import { IStyleProps, PropsClasses } from '../../../../types/StyleProps';
import style from './styles';

// project imports
import { putSettingsRequest } from '../../../../store/actions/common_actions';

// project types imports
import { IState } from '../../../../store/reducers';

// local imports
import { StyledSwitch } from '../../../../components/StyledSwitch';
import { Props, StateProps } from './types';

const useStyles = makeStyles<Theme, IStyleProps>(style as StyleRules);

const TransferVendor = (props: Props) => {
  const { translate } = props;
  const classes: PropsClasses = useStyles({} as IStyleProps);
  const dispatch = useDispatch();
  const bexioSettings = useSelector<IState, StateProps>(({ bexio: { settings } }) => settings);

  const [doNotTransferVendor, setDoNotTransferVendor] = useState(
    bexioSettings ? !bexioSettings.doNotTransferVendor : true,
  );

  useEffect(() => {
    if (!bexioSettings) {
      return;
    }
    if (doNotTransferVendor !== bexioSettings.doNotTransferVendor) {
      return;
    }
    dispatch(
      putSettingsRequest({ system: 'bexio', data: { ...bexioSettings, doNotTransferVendor: !doNotTransferVendor } }),
    );
  }, [doNotTransferVendor]);

  useEffect(() => {
    if (!bexioSettings) {
      return;
    }
    setDoNotTransferVendor(!bexioSettings.doNotTransferVendor);
  }, [bexioSettings]);

  const onChange = (ev: React.ChangeEvent) => {
    setDoNotTransferVendor(!doNotTransferVendor);
  };

  return (
    <Grid container={true}>
      <GridItem xs={4} className={classes.gridItem}>
        <InputLabel>{translate('bexio.supplier_creation')}</InputLabel>
      </GridItem>
      <GridItem xs={8} className={classes.gridItem}>
        <StyledSwitch checked={doNotTransferVendor} onChange={onChange} disabled={!bexioSettings} />
      </GridItem>
    </Grid>
  );
};

export default withLocalize(TransferVendor);
